import React, { useState } from "react";

const ShowAllReservationsPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAllReservationsPopup, setshowAllReservationsPopup] =
      useState<boolean>(false);

    const showAllReservationsToggleHandler = () => {
      setshowAllReservationsPopup(!showAllReservationsPopup);
    };

    return (
      <Component
        showAllReservationsPopup={showAllReservationsPopup}
        showAllReservationsToggleHandler={showAllReservationsToggleHandler}
        {...props}
      />
    );
  };

export default ShowAllReservationsPopupHOC;
